import React, { useCallback } from "react";

import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { forwardRef } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const KMKList = ({ list }) => {
  const renderList = () => {
    if (Array.isArray(list))
      return list.map((val) => (
        <ListItem key={val} sx={{ ...(list.length > 1 ? { display: "list-item" } : {}), padding: "0px" }}>
          {val}
        </ListItem>
      ));
    else if (typeof message == "object") {
      let messageKey = Object.keys(list);
      return messageKey.map((val) => (
        <ListItem key={val} sx={{ ...(messageKey.length > 1 ? { display: "list-item" } : {}), padding: "0px" }}>
          {list[val]}
        </ListItem>
      ));
    } else return <ListItem sx={{ padding: "0px" }}>{list}</ListItem>;
  };

  return <List sx={{ listStyleType: "disc", padding: "0 0 0 20px" }}>{renderList()}</List>;
};

const KMKSnackbar = ({ message, type, onClose, open }) => {
  const handleClose = useCallback(
    (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      onClose();
    },
    [onClose]
  );

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        open={open}
        autoHideDuration={5000}
        disableWindowBlurListener
        onClose={handleClose}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      >
        <Alert
          data-id={`${type}Alert`}
          onClose={handleClose}
          severity={type || "success"}
          sx={{
            width: "100%",
            whiteSpace: "pre",
            display: "flex !important",
            justifyContent: "center !important",
            alignItems: "center !important",
          }}
        >
          <KMKList list={message} />
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default React.memo(KMKSnackbar);
